// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"241":"b68e6c5aca96fafab156","825":"9eb772fc58e000badbc1"}[chunkId] + ".2122.js";
};